<template>
  <div class="ScrollBox">
    <div class="box-bg">
      <van-nav-bar
        :border="false"
        :title="$t('appDown[0]')"
        left-arrow
        style="background-color:transparent"
        @click-left="$router.go(-1)"
      />
      <div class="qrcode-box">
        <div class="bg">
          <div class="logo">
            <img :src="`./static/images/${Theme}/logo-assist.png`" width="100%">
          </div>
          <img :src="qrcodeImg" width="70%" style="margin:10px auto">
          <div class="link">
            <input type="text" :value="downLink" id="AppLink">
            <span id="IosLink" style="position: absolute;opacity: 0;z-index: -1">{{downLink}}</span>
            <van-button type="info" size="small" @click="$Util.CopyText('IosLink','AppLink')">{{$t('appDown[5]')}}</van-button>
          </div>
        </div>
      </div>
      <div style="padding: 15px 30px">
        <van-button block round color="#3bcbbb" style="font-size: 16px" @click="$Util.OpenUrl(downLink)">{{isIos?$t('appDown[7]'):$t('appDown[6]')}}</van-button>
      </div>
      <div class="tips">
        <van-icon name="info" size="14" style="margin-right: 5px;" />
        <div>{{$t('appDown[8]')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcode"
export default {
  name: 'AppDown',
  components: {

  },
  props: {},
  data() {
    return {
      saveN: 0,
      qrcodeImg: '',
      downLink: AppDown+'?lang='+this.$i18n.locale,
      isIos: false,
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
      this.isIos = true
      this.downLink = IosDown+'?lang='+this.$i18n.locale
    }else{
      this.isIos = false
      this.downLink = AppDown+'?lang='+this.$i18n.locale
    }
    QRCode.toDataURL(this.downLink, (err, url) => {
      if (err) throw err
      this.qrcodeImg = url
    })
  },
  mounted() {
    
  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    saveQRCode() {
      if(window.plus){
        this.saveN+=1;
        var img = $('#QRCode').find('img').attr('src').replace('data:image/png;base64,','');
        var bm = new plus.nativeObj.Bitmap();
        bm.loadBase64Data(img, ()=>{
          bm.save( '_doc/appdown'+this.saveN+'.jpg', {'overwrite':true,'format':'jpg'}, (e)=>{
            plus.gallery.save( e.target, (e)=>{  
              this.$Dialog.Toast(this.$t('AppDown[2]'))
            },(err)=>{  
              this.$Dialog.Toast(this.$t('AppDown[3]'))
            }); 
          }, (error)=>{  
            this.$Dialog.Toast(this.$t('AppDown[3]'))
          });
          setTimeout(function(){
            bm.recycle();
          },1000);
        }, (err)=>{  
          this.$Dialog.Toast(this.$t('AppDown[3]'))
        });
      }else{
        this.$Dialog.Toast(this.$t('AppDown[4]'))
      }
    },
  }
}
</script>
<style scoped>
.box-bg{
  background: url('../../public/static/images/default/appdown-bg.png') no-repeat;
  background-size: 100% 100%;
  min-height: 100%;
}
.van-nav-bar>>>.van-icon,.van-nav-bar>>>.van-nav-bar__title{
  color: #fff;
}
.qrcode-box{
  position: relative;
  margin: 100px 30px 0;
}
.qrcode-box .bg{
  background-color: var(--background-main);
  border-radius: 15px;
  padding: 20px;
  z-index: 2;
  position: relative;
  text-align: center;
  line-height: 1;
}
.qrcode-box:after{
  content: '';
  background-color: #628fe1;
  border-radius: 15px;
  height: 100%;
  position: absolute;
  top: -15px;
  left: 25px;
  right: 25px;
}
.qrcode-box .logo{
  background-color: var(--background-assist);
  border-radius: 100%;
  border: 5px var(--color-white) solid;
  width: 95px;
  height: 95px;
  padding: 15px;
  margin: -70px auto 0;
}
.qrcode-box p{
  color: var(--color-assist);
  margin-top: 10px;
}
.qrcode-box .link{
  background-color: var(--background-assist);
  border-radius: 3px;
  overflow: hidden;
  display: flex;
}
.qrcode-box .link input{
  flex: 1;
  padding: 0 10px;
  background-color: transparent;
  border: 0;
  color: var(--color-assist);
}
.tips{
  display: flex;
  color: var(--color-white);
  padding: 30px;
  line-height: 1;
  font-size: 12px;
}
</style>